export const toISODate = (date: Date): string =>
  date.toISOString().split("T")[0];
